export const SLIDER_MONTH_OPTIONS = [
    {
        value: 1,
        label: 'JAN',
    },
    {
        value: 2,
        label: 'FEB',
    },
    {
        value: 3,
        label: 'MAR',
    },
    {
        value: 4,
        label: 'APR',
    },
    {
        value: 5,
        label: 'MAY',
    },
    {
        value: 6,
        label: 'JUN',
    },
    {
        value: 7,
        label: 'JUL',
    },
    {
        value: 8,
        label: 'AUG',
    },
    {
        value: 9,
        label: 'SEP',
    },
    {
        value: 10,
        label: 'OCT',
    },
    {
        value: 11,
        label: 'NOV',
    },
    {
        value: 12,
        label: 'DEC',
    },
];

export const ANALYSIS_PREFIX = 'Analysis/';

export const ANALYSIS_CHALLENGES_REQUESTED = `${ANALYSIS_PREFIX}/ANALYSIS_CHALLENGES_REQUESTED`;
export const ANALYSIS_CHALLENGES_SUCCEEDED = `${ANALYSIS_PREFIX}/ANALYSIS_CHALLENGES_SUCCEEDED`;
export const ANALYSIS_CHALLENGES_FAILED = `${ANALYSIS_PREFIX}/ANALYSIS_CHALLENGES_FAILED`;

export const ANALYSIS_RESEARCHERS_REQUESTED = `${ANALYSIS_PREFIX}/ANALYSIS_RESEARCHERS_REQUESTED`;
export const ANALYSIS_RESEARCHERS_SUCCEEDED = `${ANALYSIS_PREFIX}/ANALYSIS_RESEARCHERS_SUCCEEDED`;
export const ANALYSIS_RESEARCHERS_FAILED = `${ANALYSIS_PREFIX}/ANALYSIS_RESEARCHERS_FAILED`;

export const ANALYSIS_SEGMENTS_REQUESTED = `${ANALYSIS_PREFIX}/ANALYSIS_SEGMENTS_REQUESTED`;
export const ANALYSIS_SEGMENTS_SUCCEEDED = `${ANALYSIS_PREFIX}/ANALYSIS_SEGMENTS_SUCCEEDED`;
export const ANALYSIS_SEGMENTS_FAILED = `${ANALYSIS_PREFIX}/ANALYSIS_SEGMENTS_FAILED`;

export const SEGMENTS_REPORT_REQUESTED = `${ANALYSIS_PREFIX}/SEGMENTS_REPORT_REQUESTED`;
export const SEGMENTS_REPORT_SUCCEEDED = `${ANALYSIS_PREFIX}/SEGMENTS_REPORT_SUCCEEDED`;
export const SEGMENTS_REPORT_FAILED = `${ANALYSIS_PREFIX}/SEGMENTS_REPORT_FAILED`;

export const TOP_OBJECTS_REQUESTED = `${ANALYSIS_PREFIX}/TOP_OBJECTS_REQUESTED`;
export const TOP_OBJECTS_SUCCEEDED = `${ANALYSIS_PREFIX}/TOP_OBJECTS_SUCCEEDED`;
export const TOP_OBJECTS_FAILED = `${ANALYSIS_PREFIX}/TOP_OBJECTS_FAILED`;

export const TOP_MATERIALS_REQUESTED = `${ANALYSIS_PREFIX}/TOP_MATERIALS_REQUESTED`;
export const TOP_MATERIALS_SUCCEEDED = `${ANALYSIS_PREFIX}/TOP_MATERIALS_SUCCEEDED`;
export const TOP_MATERIALS_FAILED = `${ANALYSIS_PREFIX}/TOP_MATERIALS_FAILED`;

export const TOP_BRANDS_REQUESTED = `${ANALYSIS_PREFIX}/TOP_BRANDS_REQUESTED`;
export const TOP_BRANDS_SUCCEEDED = `${ANALYSIS_PREFIX}/TOP_BRANDS_SUCCEEDED`;
export const TOP_BRANDS_FAILED = `${ANALYSIS_PREFIX}/TOP_BRANDS_FAILED`;

export const OBJECTS_TAGS_REQUESTED = `${ANALYSIS_PREFIX}/OBJECTS_TAGS_REQUESTED`;
export const OBJECTS_TAGS_SUCCEEDED = `${ANALYSIS_PREFIX}/OBJECTS_TAGS_SUCCEEDED`;
export const OBJECTS_TAGS_FAILED = `${ANALYSIS_PREFIX}/OBJECTS_TAGS_FAILED`;

export const MATERIALS_TAGS_REQUESTED = `${ANALYSIS_PREFIX}/MATERIALS_TAGS_REQUESTED`;
export const MATERIALS_TAGS_SUCCEEDED = `${ANALYSIS_PREFIX}/MATERIALS_TAGS_SUCCEEDED`;
export const MATERIALS_TAGS_FAILED = `${ANALYSIS_PREFIX}/MATERIALS_TAGS_FAILED`;

export const BRANDS_TAGS_REQUESTED = `${ANALYSIS_PREFIX}/BRANDS_TAGS_REQUESTED`;
export const BRANDS_TAGS_SUCCEEDED = `${ANALYSIS_PREFIX}/BRANDS_TAGS_SUCCEEDED`;
export const BRANDS_TAGS_FAILED = `${ANALYSIS_PREFIX}/BRANDS_TAGS_FAILED`;

export const HEATMAP_LITTERS_REQUESTED = `${ANALYSIS_PREFIX}/HEATMAP_LITTERS_REQUESTED`;
export const HEATMAP_LITTERS_SUCCEEDED = `${ANALYSIS_PREFIX}/HEATMAP_LITTERS_SUCCEEDED`;
export const HEATMAP_LITTERS_FAILED = `${ANALYSIS_PREFIX}/HEATMAP_LITTERS_FAILED`;

export const SEGMENTS_INDEX_REQUESTED = `${ANALYSIS_PREFIX}/SEGMENTS_INDEX_REQUESTED`;
export const SEGMENTS_INDEX_SUCCEEDED = `${ANALYSIS_PREFIX}/SEGMENTS_INDEX_SUCCEEDED`;
export const SEGMENTS_INDEX_FAILED = `${ANALYSIS_PREFIX}/SEGMENTS_INDEX_FAILED`;

export const INTENSITY_LEGENDS = [
    {
        color: '#c93232',
        max: 30,
        label: '30',
        min: 20,
    },
    {
        color: '#d2502a',
        max: 20,
        label: '20',
        min: 10,
    },
    {
        color: '#db6e22',
        max: 10,
        label: '10',
        min: 5,
    },
    {
        color: '#e38b1a',
        max: 5,
        label: '5',
        min: 2,
    },
    {
        color: '#f0ad0e',
        max: 2,
        label: '2',
        min: 1,
    },
    {
        color: '#ffd300',
        max: 1,
        label: '1',
        min: 0.75,
    },
    {
        color: '#c1bd3f',
        max: 0.75,
        label: '0.75',
        min: 0.5,
    },
    {
        color: '#83a77d',
        max: 5,
        label: '0.50',
        min: 0.25,
    },
    {
        color: '#3f8fc2',
        max: 0.25,
        label: '0.25',
        min: 0.1,
    },
    {
        color: '#027aff',
        max: 0.1,
        label: '< = 0.1',
        min: Number.MIN_SAFE_INTEGER,
    },
];
